import { render, staticRenderFns } from "./TermOrderComponent.vue?vue&type=template&id=63c9c8f6"
import script from "./TermOrderComponent.vue?vue&type=script&lang=js"
export * from "./TermOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports